export default {
  GFPP: 'f274e40f-5623-4ef3-ad58-e147a5e41dc9',
  LANGUAGE_PANEL: '005b2f90-d675-4947-911c-3e23e812948d',
  TRANSLATION_MODE: '559f40e1-216b-43fe-a37e-c0cc3e4ad6a8',
  MY_SITE_LANGUAGES: '13de454b-f7a2-4bf6-b4a0-8e5d001f2720',
};
